import { render } from "./price-comparison.vue?vue&type=template&id=02cfc12c&scoped=true"
import script from "./price-comparison.vue?vue&type=script&lang=js"
export * from "./price-comparison.vue?vue&type=script&lang=js"

import "./price-comparison.vue?vue&type=style&index=0&id=02cfc12c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02cfc12c"]])

export default __exports__